import coverImg1 from '../img/blog_image/blog_1.webp';
import coverImg2 from '../img/blog_image/blog_2.webp';
import coverImg3 from '../img/blog_image/blog_3.webp';

export const blogImages = {
  'jetpeel-technology': {
    cover: coverImg1,
    card: coverImg1,
  },
  'tired-skin-jetpeel': {
    cover: coverImg2,
    card: coverImg2,
  },
  'singlejet-narrow': {
    cover: coverImg3,
    card: coverImg3,
  },
};
